export default "assets/facebook-3cb92aed.svg";